import MoreLoginOptions from './MoreLoginOptions'

export default MoreLoginOptions
